function myFilter(filter, data) {
    // Eğer filter geçersiz, undefined, null veya "Kaikki Tuotteet" ise tüm veriyi döndür
    if (!filter || filter.toLowerCase() === "kaikki tuotteet") {
      return data;
    }
    
    // Büyük/küçük harf duyarlılığını kaldırmak için filter'ı küçük harfe çevir
    let normalizedFilter = filter.toLowerCase();
    if (normalizedFilter === "nojatuolit") {
        normalizedFilter = "nojatuoli";
      } 
    return data.filter((item) => {
      // Eğer "Uusi" filtrelendiyse sadece "Uudet Huonekalut" türünü getir
      if (normalizedFilter === "kaikki sohvat" ) {
        return( item.type.toLowerCase() == "2-3 istuttavat sohvat" ||
                item.type.toLowerCase() =='vuodesohvat'||
                item.type.toLowerCase() =='kulmasohvat'||
                item.type.toLowerCase() =='divaanisohvat');
      }
      if (normalizedFilter === 'sängyt' || normalizedFilter === 'sänky') {
        return( item.type.toLowerCase() == "sänky");
      }
      if (normalizedFilter === "uusi" || normalizedFilter === "uudet huonekalut" || normalizedFilter === 'uusi huonekalut') {
        return( item.condition.toLowerCase() === "käyttämätön" &&
                item.type.toLowerCase() !=='matot');
      }
  
      // Hem type hem de name alanında filter'ı kontrol et
      return (
        item.type.toLowerCase().includes(normalizedFilter) ||
        item.name.toLowerCase().includes(normalizedFilter)
      );
      
    });
  }
  
  export default myFilter;